<template>
  <b-row v-if="this.sorry_invoice_not_found">
    <div class="col-12 text-center" style="padding: 100px 0">
      <h2 class="text-primary">{{ $t('sorry_invoice_not_found') }}</h2>
    </div>
  </b-row>
  <b-card v-else-if="item">
    <div v-if="!auditTrial">
      <b-row class="col-md-12 mb-1 pr-0">
        <div class="col-md-6">
          <h3 class="font-weight-bolder">
            <b-link class="btn btn-outline-primary" to="/invoices">
              <FeatherIcon icon="ChevronLeftIcon"></FeatherIcon>
              {{ $t("back") }}
            </b-link>
            {{ $t("invoice_id") }} : I-{{ item.id }}
          </h3>
        </div>
      </b-row>
      <template v-if="global_settings && !item.offer_confirmed && item.status > 0">
        <b-row class="ml-1 mr-1" v-if="item.status == 2">
          <b-col class="alert alert-danger p-2 col-md-12">
            <h4>
              <b-avatar variant="light-danger" class="ml-1 mr-1" size="45">
                <feather-icon icon="AlertTriangleIcon" size="21"/>
              </b-avatar>
              <span class="text-danger font-lg" v-if="item.msg">{{ $t(item.msg) }}</span>
            </h4>
          </b-col>
        </b-row>
        <b-row class="ml-1 mr-1" v-else-if="global_settings.status && !item.offer_confirmed">
          <b-col class="alert alert-success p-2 text-black-50">
            <template>
              <p class="text-dark" style="font-size: 16px;">{{ $t('wait_offer_message') }}</p>
            </template>
          </b-col>
        </b-row>
        <b-row class="ml-1 mr-1" v-else>
          <b-col :class="item.status == 2 ? 'alert alert-danger' : 'alert alert-secondary'" class="p-2 col-md-12">
            <h4>
              <b-avatar :variant="item.status == 2 ? 'light-danger' : 'light-secondary'" class="ml-1 mr-1" size="45">
                <feather-icon icon="AlertTriangleIcon" size="21"/>
              </b-avatar>
              <span :class="item.status == 2 ? 'text-danger' : 'text-secondary'" class="font-lg" v-if="item.msg">{{ $t(item.msg) }}</span>
            </h4>
          </b-col>
        </b-row>
      </template>

      <b-row class="ml-1 mr-1" v-if="item && item.scorings && item.scorings.length > 0 && item.offer_confirmed">
        <b-col class="alert alert-success p-2 text-black-50">

          <template>
            <b-row class="m-0">
              <div align="start" class="col-md-6 mr-0 pr-0">
                <InvoiceStatus :invoice="item" :status="item.status"/>
              </div>
            </b-row>
            <b-row class="m-0 col-md-12">
              <b-row class="m-0 col-md-12 p-0 justify-content-between">
                <b-col class="font-weight-bolder text-black-50 p-1" md="2">
                  <h5>
                    {{ $t("rating") }}
                    <feather-icon icon="HelpCircleIcon" size="18" v-b-tooltip.hover :title="$t('invoice_info_rating_tooltip')"/>
                    <br/>
                    {{ item.scorings[0].rating }}
                  </h5>
                </b-col>
                <b-col class="font-weight-bolder text-black-50 p-1" md="2">
                  <h5>
                    {{ item.is_reverse == 1 ? $t("surcharge_in_%") : $t("invoice_info_discount_percent") }}

                    <feather-icon icon="HelpCircleIcon" size="18" v-b-tooltip.hover :title="$t('invoice_info_discount_percent_tooltip')"/>
                    <br/>

                    {{ item && item.scorings ? Number(CalculationsHelper.getSellerDiscountPercentage(item)).toFixed(2) : ""  }}%
                  </h5>
                </b-col>
                <b-col class="font-weight-bolder text-black-50 p-1" md="2" v-if="item && item.scorings ? Number(item.scorings[0].refund_percentage) : 0">
                  <h5>
                    {{ $t("invoice_info_risk_discount_late_percent") }}
                    <feather-icon icon="HelpCircleIcon" size="18" v-b-tooltip.hover :title="$t('invoice_info_risk_discount_late_percent_tooltip')"/>
                    <br/>
                    {{ CalculationsHelper.getRefundPercentage(item) }}%
                  </h5>
                </b-col>
                <b-col class="font-weight-bolder text-black-50 p-1" md="2" v-if="Number(CalculationsHelper.getRefundDefaultPercentage(item))">
                  <h5>
                    {{ $t("invoice_info_risk_discount_default_percent") }}
                    <feather-icon icon="HelpCircleIcon" size="18" :title="$t(options[3].title)" v-b-tooltip.hover/>
                    <br/>
                    {{ CalculationsHelper.getRefundDefaultPercentage(item) }} %
                  </h5>
                </b-col>
                <b-col class="font-weight-bolder text-black-50 p-1" md="2">
                  <h5>
                    {{ $t("type") }}
                    <feather-icon icon="HelpCircleIcon" size="18" v-b-tooltip.hover :title="$t('invoice_info_factoring_type_tooltip')"/>
                    <br/>

                    <template v-if="item.recourse == 0">
                      <span>{{ $t("Non-Recourse") }}</span>
                    </template>
                    <template v-else>
                      <span v-if="item.is_reverse == 1">{{ $t("Reverse") }}</span>
                      <span v-else>{{ $t("Recourse") }}</span>
                    </template>
                  </h5>
                </b-col>
              </b-row>
              <b-row class="m-0 col-md-12 p-0 justify-content-between">
              <b-col class="font-weight-bold text-black-50 p-1" md="2">
                <h5>
                  {{ $t("effective_value") }}
                  <feather-icon icon="HelpCircleIcon" size="18" v-b-tooltip.hover :title="$t('invoice_info_payout_tooltip')"/>
                  <br/>
                  {{ item ? amountFormat(CalculationsHelper.getLiquidityAmount(item), item.currency.name) : 0 }}
                </h5>
              </b-col>

                <b-col class="font-weight-bold text-black-50 p-1" md="2">
                  <h5>
                    {{ item.is_reverse == 1 ? $t("surcharge") : $t("invoice_info_discount_amount") }}
                    <feather-icon icon="HelpCircleIcon" size="18" v-b-tooltip.hover :title="$t('invoice_info_discount_amount_tooltip')"/>
                    <br/>
                    {{ item ? amountFormat(CalculationsHelper.getSellerDiscountAmount(item), item.currency.name) : 0 }}
                  </h5>
                </b-col>
                <b-col class="font-weight-bold text-black-50 p-1" md="2" v-if="item && item.scorings
                        ? Number(CalculationsHelper.getRefundAmount(item))
                        : 0">
                <h5>
                  {{ $t("invoice_info_risk_discount_late_amount") }}
                  <feather-icon icon="HelpCircleIcon" size="18" v-b-tooltip.hover :title="$t('invoice_info_risk_discount_late_amount_tooltip')"/>
                  <br/>
                  {{
                    item && item.scorings
                        ? amountFormat(CalculationsHelper.getRefundAmount(item), item.currency.name)
                        : 0
                  }}
                </h5>
              </b-col>
              <b-col class="font-weight-bold text-black-50 p-1" md="2"
              v-if="item && item.scorings ? Number(CalculationsHelper.getRefundDefaultAmount(item), item.currency.name) : 0">
                <h5>
                  {{ $t("invoice_info_risk_discount_default_amount") }}
                  <feather-icon icon="HelpCircleIcon" size="18" :title="$t(options[4].title)" v-b-tooltip.hover/>
                  <br/>
                  {{ item && item.scorings ? amountFormat(CalculationsHelper.getRefundDefaultAmount(item), item.currency.name) : 0 }}
                </h5>
              </b-col>
              <b-col class="font-weight-bold text-black-50 p-1" md="2" v-if="item.is_reverse != 1">
                <h5>
                  {{
                    item.recourse == 2 ? $t("confirmation_by_supplier") :
                        $t("confirmation_by_debtor")
                  }}
                  <feather-icon icon="HelpCircleIcon" size="18" v-b-tooltip.hover :title="$t('invoice_info_debtor_confirmation_tooltip')"/>
                  <br/>
                  <span v-if="item.debtor_confirmed == 1">{{ $t("confirmed") }}</span>
                  <span v-else-if="item.recourse == 1"> {{ $t("not_needed") }}</span>
                  <span v-else> {{ $t("required") }}</span>
                </h5>
              </b-col>
              <b-col class="font-weight-bold text-black-50 p-1" md="2" v-if="item.is_reverse == 1">

                <h5>
                  {{ $t("repayment_amount") }}
                  <feather-icon icon="HelpCircleIcon" size="18"/>
                  <br/>
                  {{
                    item && item.scorings
                        ? amountFormat(CalculationsHelper.getRepaymentAmount(item), item.currency.name)
                        : 0
                  }}
                </h5>
              </b-col>
              </b-row>
            </b-row>
          </template>
        </b-col>
      </b-row>

      <b-row class="ml-1 mr-1 mt-2" v-if="item && item.scorings && item.scorings.length > 0
      && item.offer_confirmed && Number(item.scorings[0].refund_percentage)">
        <b-col class="alert alert-info p-2 text-black-50" v-if="item.is_reverse === 1">
          {{ $t('refund_description_reverse', { percent: CalculationsHelper.getRefundPercentage(item)}) }}
        </b-col>
        <b-col class="alert alert-info p-2 text-black-50" v-else-if="item.recourse === 1">
          {{ $t('refund_description_recourse', { percent: CalculationsHelper.getRefundPercentage(item)}) }}
        </b-col>
        <b-col class="alert alert-info p-2 text-black-50" v-else>
          {{ $t('refund_description_non_recourse', { percent: CalculationsHelper.getRefundPercentage(item)}) }}
        </b-col>
      </b-row>

      <b-row class="ml-1 mr-1 mt-2" v-if="item && item.scorings && item.scorings.length > 0
       && item.offer_confirmed && Number(CalculationsHelper.getRefundDefaultPercentage(item))">
        <b-col class="alert alert-info p-2 text-black-50" v-if="item.is_reverse === 1">
          {{ $t('refund_default_description_reverse', { percent: CalculationsHelper.getRefundDefaultPercentage(item)}) }}
        </b-col>
        <b-col class="alert alert-info p-2 text-black-50" v-else-if="item.recourse === 1">
          {{ $t('refund_default_description_recourse', { percent: CalculationsHelper.getRefundDefaultPercentage(item)}) }}
        </b-col>
        <b-col class="alert alert-info p-2 text-black-50" v-else>
          {{ $t('refund_default_description_non_recourse', { percent: CalculationsHelper.getRefundDefaultPercentage(item)}) }}
        </b-col>
      </b-row>

      <validation-observer ref="formValidate">
        <b-form @submit.prevent>
          <div class="col-md-12 mt-1">
            <b-row m-0 p-0 v-if="!load">
              <b-col class="mt-2 pl-0" lg="12" md="12" sm="12" xl="12">
                <b-form-group class="d-flex" v-slot="{ ariaDescribedby }">
                  <validation-provider #default="{ errors }" :name="$t('recourse')" rules="required">
                    <div class="col-12 d-flex">
                      <b-form-radio :aria-describedby="ariaDescribedby" :disabled="item.status != 0"
                                    :title="$t(options[0].title)" @blur="editInvoice()"
                                    class="mr-2" id="nonRecourseTooltip" v-b-tooltip.hover v-model="item.recourse"
                                    value="0">
                        {{ $t("Non-recourse") }}
                      </b-form-radio>
                      <b-form-radio :aria-describedby="ariaDescribedby" :disabled="item.status != 0"
                                    :title="$t(options[1].title)" @blur="editInvoice()"
                                    class="mr-2" id="recourseTooltip" v-b-tooltip.hover v-model="item.recourse"
                                    value="1">
                        {{ $t("Recourse") }}
                        <small>{{ $t("recourse_text") }}</small>
                      </b-form-radio>
                      <b-form-radio :aria-describedby="ariaDescribedby" :disabled="item.status != 0"
                                    :title="$t(options[2].title)"
                                    @blur="editInvoice()" class="mr-2" id="reverseTooltip" v-model="item.recourse"
                                    value="2">
                        {{ $t("Reverse") }}
                      </b-form-radio>
                    </div>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col class="" lg="8" md="8" sm="12" xl="8">
                <b-form-group :label="(item.recourse == 2 ? $t('supplier') : $t('deptor')) + ':'"
                              class="font-weight-bolder" id="deptor" label-for="deptor"
                              v-if="item.company_name == '' || !item.issuer_id">
                  <validation-provider #default="{ errors }" :name="item.recourse == 2 ? $t('supplier') : $t('deptor')"
                                       rules="required">
                    <vue-autosuggest :disabled="item.status != 0"
                                     :input-props="{ id: 'autosuggest__input', class: 'form-control' }" :limit="10"
                                     :suggestions="filteredOptions" @keyup="searchForCompaniesName(item)"
                                     @selected="onSelected($event, item, index)" v-model.trim="item.company_name">
                      <template slot-scope="{ suggestion }">
                        <span class="my-suggestion-item">{{ suggestion.item }}
                        </span>
                      </template>
                    </vue-autosuggest>
                    <b-button class="mt-1" disabled v-if="showHint" variant="primary">
                      <b-spinner small type="grow"></b-spinner>
                      {{ $t("loading") }}...
                    </b-button>
                    <div class="alert alert-secondary p-1 mt-1" v-if="companyMessage">
                      <span v-if="$store.state.app.language == 'en'">
                        Please enter the company name in this field exactly as it appears in the official commercial register. If you still cannot find the company of your
                        {{ item.is_reverse == 1 ? 'supplier' : 'debtor' }} on the list, please contact the administrator at
                        <a href="mailto:support@aequitex.com" class="font-weight-bolder" >support@aequitex.com</a>
                        or <a @click="openLink()" class="font-weight-bolder">book a meeting here.</a>
                      </span>

                      <span v-else-if="$store.state.app.language == 'de'">
                        Bitte geben Sie den Firmennamen in diesem Feld genau so ein, wie er im offiziellen Handelsregister hinterlegt wurde. Falls Sie das Unternehmen Ihres
                        {{ item.is_reverse == 1 ? 'Anbieter' : 'Schuldners' }} oder Zulieferers dann immer noch nicht in der Liste finden können, wenden Sie sich bitte an den Administrator unter
                        <a href="mailto:support@aequitex.com" class="font-weight-bolder">support@aequitex.com</a>
                        oder vereinbaren Sie <a @click="openLink()" class="font-weight-bolder" style="text-decoration:underline;">hier</a> einen Termin.
                     </span>
                    </div>
                    <small class="text-danger">{{ $t(errors[0]) }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group :label="(item.recourse == 2 ? $t('supplier') : $t('deptor')) + ':'"
                              class="font-weight-bolder" id="deptor" label-for="deptor"
                              v-else>
                  <validation-provider #default="{ errors }"
                                       :name="(item.recourse == 2 ? $t('supplier') : $t('deptor'))" rules="required">
                    <b-form-input disabled v-model.trim="item.debtor.name"></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <img height="50" src="/new-loader.svg" v-if="loader" width="50"/>
              </b-col>

              <b-col lg="4" md="4" sm="12" xl="4">
                <b-form-group
                    :label="$t('currency') + ':'"
                    clasa="d-flex flex-direction-column"
                    class="font-weight-bolder"
                    id="currency"
                    label-for="currency"
                >
                  <b-dropdown
                      class="w-50 no-arrow"
                      id="currency-dropdown"
                      :disabled="item && item.status != 0"
                      variant="outline-dark"
                  >
                    <template #button-content>
                      <template v-if="item && item.currency">
                        <span v-if="currency_name">{{ currency_name }}</span>
                        <span v-else>{{ item.currency.name }}</span>
                      </template>
                      <template v-else>
                        <span v-if="currency_name">{{ currency_name }}</span>
                        <span v-else>{{ $t('select_currency') }}</span>
                      </template>
                    </template>

                    <b-dropdown-item
                        :key="option.id"
                        :value="option.id"
                        @click="changeCurrency(option.id, option.name)"
                        v-for="option in currencies"
                    >
                      {{ option.name }}
                    </b-dropdown-item>

                  </b-dropdown>

                  <div>
                    <small class="text-danger" v-if="currencyError">{{ $t(currencyError) }}</small>
                  </div>
                </b-form-group>
              </b-col>

              <b-col lg="6" md="6" sm="12" xl="6">
                <b-form-group :label="$t('invoice_amount') + ':'" class="font-weight-bolder" id="amount"
                              label-for="amount">
                  <validation-provider #default="{ errors }" :name="$t('invoice_amount')" rules="required">
                    <b-form-input :disabled="item.status != 0"
                                  :input-props="{
                        class: 'form-control',
                      }"
                                  id="amount-input" placeholder="00'000.00" v-model.trim="item.amount"></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="6" md="6" sm="12" xl="6">
                <b-form-group
                    :label="$t('issue_date') + ':'"
                    class="font-weight-bolder"
                    id="issue_date"
                    label-for="issue_date"
                >
                  <validation-provider
                      #default="{ errors }"
                      :name="$t('issue_date')"
                      rules="required"
                  >
                    <div>
                      <b-form-datepicker
                          :max="disabledDates"
                          :disabled="item.status != 0"
                          :locale="$store.state.app && $store.state.app.language == 'de' ? 'de' : 'en'"
                          :placeholder="$t('choose_a_date')"
                          :state="errors.length > 0 ? false : null"
                          @blur="editInvoice()"
                          @input="changeTerms(item)"
                          id="issue_date_datepicker" no-flip required
                          v-model.trim="item.issue_date"
                      >
                      </b-form-datepicker>
                    </div>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="3" md="3" sm="12" xl="3">
                <b-form-group
                    class="font-weight-bolder"
                    disabled
                    id="payment_date"
                    label-for="payment_date"
                >
                <template #label>
                  {{ $t('payment_term_in_days')  + ' :' }}
                  <feather-icon v-b-tooltip.hover :title="$t('payment_terms_in_days_tooltip')" icon="HelpCircleIcon" size="18" />
                </template>
                  <validation-provider
                      #default="{ errors }"
                      :name="$t('payment_term_in_days')"
                      rules="required"
                  >
                    <b-form-input
                        :disabled="true"
                        @blur="editInvoice()"
                        id="payment_date"
                        v-model.trim="item.terms"
                    ></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small class="text-danger" v-if="errorDueDate.length > 0">{{ errorDueDate }}
                    </small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="3" md="3" sm="12" xl="3">
                <b-form-group
                    class="font-weight-bolder"
                    id="due_days_calculated"
                    label-for="due_days_calculated"
                >
                <template #label>
                  {{ $t('due_days_calculated') +  ' :' }}
                  <feather-icon v-b-tooltip.hover :title="$t('financing_due_days_tooltip')"  icon="HelpCircleIcon" size="18" />
                </template>
                  <validation-provider
                      #default="{ errors }"
                      :name="$t('due_days_calculated')"
                      rules="required"
                  >
                    <b-form-input
                        :disabled="true"
                        id="due_days_calculated"
                        v-model.trim="item.due_days_calculated"
                    ></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="6" md="6" sm="12" xl="6">
                <b-form-group
                    :label="$t('due_date')+ ':'"
                    class="font-weight-bolder"
                    id="due_date"
                    label-for="due_date"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="due_date"
                      rules="required"
                  >
                    <b-form-datepicker
                        :min="disabledDueDates"
                        :disabled="item.status != 0"
                        :locale="$store.state.app && $store.state.app.language == 'de' ? 'de' : 'en'"
                        :placeholder="$t('choose_a_date')"
                        @input="changeTerms(item)"
                        id="due_date_input"
                        no-flip
                        required
                        v-model.trim="item.due_date"></b-form-datepicker>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="6" md="6" sm="12" xl="6">
                <b-form-group :label="$t('invoice_number') + ':'" class="font-weight-bolder" label-for="invoice_number">
                  <validation-provider #default="{ errors }" :name="$t('invoice_number')" rules="required">
                    <b-form-input :disabled="item.status != 0"
                                  id="invoice_number" v-model.trim="item.invoice_number"></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="6" md="6" sm="12" xl="6">
                <b-form-group :label="$t('set_invoice_auto_remove_days') + ':'" class="font-weight-bolder" label-for="set_invoice_auto_remove_days">
                  <b-form-input
                      id="set_invoice_auto_remove_days"
                      type="number"
                      min="0"
                      max="999"
                      :disabled="item && item.status != 0 && !canRepublish(item)"
                      v-model.number="item.auto_remove_days"
                  />

                </b-form-group>
                <div class="mt-1 text-danger" v-if="error">{{ $t(error) }}</div>
              </b-col>

              <b-col class="my-3" sm="12" v-if="item.recourse != 0 && (item.status == 5 || item.status == 6)">
                <template v-if="item.offer_confirmed == 1 && isAllowedToAcknowledge">
                  <template v-if="item.is_reverse != 1">
                    <template v-if="pdfUrl && !documentSigned">
                      <iframe
                          :src="pdfUrl"
                          style="width: 100%; height: 1000px; border: none;"
                      ></iframe>
                      <div style="width: 100%; text-align: right; margin-top: 20px;" v-if="pdfUrl">
                        <button
                            type="button"
                            class="btn btn-primary"
                            @click="handleButtonClick"
                        >
                          <span v-if="!buttonLoad">
                            {{ $t('skr_btn') }}
                          </span>
                          <img v-else width="100" height="25" src="/new-loader.svg" alt="loader"/>
                        </button>

                        <p v-if="skribbleError" class="text-danger mt-2" style="text-align: right;">
                          {{ $t(skribbleError) }}
                        </p>

                        <SkribblePopup
                            :show="showPopup"
                            @cancel="showPopup = false"
                            @continue="handlePopupConfirm"
                        />
                      </div>
                    </template>

                    <div v-else-if="documentSigned" class="p-4 text-center">
                      <h3 class="text-success text-large">{{ $t('skr_invoice_document_signed') }}</h3>
                    </div>

                    <div v-else class="col-12">
                      <img src="/new-loader.svg"  alt="loader"/>
                    </div>
                  </template>
                  <template v-else>
                    <template v-if="pdfUrl && !documentSigned">
                      <iframe
                          :src="pdfUrl"
                          style="width: 100%; height: 1000px; border: none;"
                      ></iframe>

                      <div style="width: 100%; text-align: right; margin-top: 20px;" v-if="pdfUrl">
                        <button
                            type="button"
                            class="btn btn-primary"
                            @click="handleButtonClick"
                        >
                          <span v-if="!buttonLoad">
                            {{ $t('skr_btn') }}
                          </span>
                          <img v-else width="100" height="25" src="/new-loader.svg" alt="loader"/>
                        </button>

                        <SkribblePopup
                            :show="showPopup"
                            @cancel="showPopup = false"
                            @continue="handlePopupConfirm"
                        />
                      </div>
                    </template>

                    <div v-else-if="documentSigned" class="p-4 text-center">
                      <h3 class="text-success text-large">{{ $t('skr_invoice_document_signed') }}</h3>
                    </div>

                    <div v-else class="col-12">
                      <img src="/new-loader.svg" alt="loader"/>
                    </div>
                  </template>
                </template>
                <template v-if="!isAllowedToAcknowledge">
                  <div>
                    <h4 class="text-center text-primary">{{ $t('acknowledgment_notice') }}</h4>
                  </div>
                </template>
              </b-col>

              <b-col lg="12" md="12" sm="12" xl="12" v-if="canRepublish(item)">
                <div style="width: 100%; text-align: right">
                  <button
                      type="button"
                      class="btn btn-primary"
                      @click="rePublish"
                  >
                    <span>
                      {{ $t('republish') }}
                    </span>
                  </button>
                </div>
              </b-col>
              <!-- Unified documents & legal text block (status 0 only) -->
              <b-col
                  sm="12"
                  xl="12"
                  md="12"
                  lg="12"
                  class="mt-1"
                  v-if="item.status == 0"
              >
                <InvoiceDocuments
                    :invoice="item"
                    :index="0"
                    :uploadRecourseFile="uploadRecourseFile"
                    :triggerFileInput5="triggerFileInput5"
                    :triggerFileInputAFS="triggerFileInputAFS"
                    :triggerFileInputBS="triggerFileInputBS"
                    :triggerFileInputIFS="triggerFileInputIFS"
                    :triggerFileInputMA="triggerFileInputMA"
                    :triggerFileInputPO="triggerFileInputPO"
                    :triggerFileInputDC="triggerFileInputDC"
                    :triggerFileInputSOW="triggerFileInputSOW"
                    :changeInvoiceFact="() => {}"
                    :acceptReverseChange="() => {}"
                    :acceptReverseError="false"
                    :filesNameSupporting="filesNameSupporting"
                    :filesNameAnnualFinancialStatements="filesNameAnnualFinancialStatements"
                    :filesNameBankStatement="filesNameBankStatement"
                    :filesNameInterimFinancialStatements="filesNameInterimFinancialStatements"
                    :filesNameMasterAgreement="filesNameMasterAgreement"
                    :filesNamePurchaseOrder="filesNamePurchaseOrder"
                    :filesNameDeliveryConfirmation="filesNameDeliveryConfirmation"
                    :filesNameStatementOfWork="filesNameStatementOfWork"
                />
              </b-col>
            </b-row>

            <b-row cols="12" lg="6" md="6" v-else xl="6">
              <img src="/new-loader.svg"/>
            </b-row>
          </div>

          <b-row class="col-md-12 mt-2" v-if="false">
            <b-col class="row blue-jumbotron row mt-1 ml-1 mr-1 pt-2 pb-2">
              <b-col class="pb-0 mb-0" md="12">
                <div class="text-decoration-underline">
                  Diese AGB's gelten. Wir machen Sie insbesondere darauf
                  aufmerksam, dass Falschangaben strafrechtlich geahndet werden
                  können.
                </div>

                <ul>
                  <li>A</li>
                  <li>B</li>
                  <li>C</li>
                </ul>
                <div class="row col-md-12">
                  <b-checkbox v-model.trim="agreeTerms"></b-checkbox>
                  <label for="agree">
                    {{ $t("i_have_read_and_agree_with") }}</label>
                </div>
              </b-col>
            </b-col>
          </b-row>
          <b-row class="col-md-12 mr-0 pr-0">
            <b-col align="start" md="6">
              <b-row align="start" class="mt-1 justify-content-start col-6">
                <b-button @click="
                  changeModalInfo(
                    'remove',
                    $t('remove'),
                    $t('are_you_sure_you_want_to_remove_this_invoice')
                  )
                  " class="mr-1 mb-1" v-b-modal.approveModal v-if="item.status != 1" variant="primary">
                  {{ $t("remove") }}
                </b-button>
              </b-row>
            </b-col>
            <b-col align="end" md="6">
              <b-row align="end" class="mt-1 justify-content-end">
                <img height="50" src="/new-loader.svg" v-if="disabledOffer" width="50"/>

                <b-button :disabled="item.status == '3' ||
                  disabledOffer
                  " @click="getOffer()" class="mr-2 mb-1" type="button" v-if="item.status == '0'" variant="primary">{{
                    $t("send_offer")
                  }}
                </b-button>
                <b-button :disabled="item && item.scorings && item.scorings.length > 0" @click="scoreInvoice()"
                          class="mr-2 mb-1" type="submit" v-if="item.status == '3'" variant="primary">{{
                    $t("score_invoice")
                  }}
                </b-button>

                <img height="50" src="/new-loader.svg" v-if="disableSell && sellingInvoice" width="50"/>
                <template v-if="item.offer_confirmed">
                  <b-button
                      v-if="canSellInvoice"
                      :disabled="disableSell"
                      @click="sellInvoice2()"
                      class="mr-2 mb-1"
                      variant="success"
                  >
                    {{ $t("sell_invoice") }}
                  </b-button>
                </template>

              </b-row>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      <div class="col-md-12 mt-2">
        <b-col class="blue-jumbotron mt-1 pt-2 pb-2">
          <b-row class="justify-content-between col-md-12 mb-0">
            <b-col class="">
              <h6>{{ $t("invoice") }}:</h6>
            </b-col>
          </b-row>

          <b-col>
            <div class="row col-md-12">
              <h5 class="mr-2 d-flex col-12">
                <b-link class="">
                  <feather-icon @click="readInvoice(item)" class="pointer web" icon="BookOpenIcon" size="22"/>
                </b-link>
                <b-link class="col-12" @click="readInvoice(item)">
                  <feather-icon class="pointer mobile" icon="BookOpenIcon" size="22"/>
                  {{ item.title }}
                </b-link>
              </h5>
              <div class="col-12">
                {{ item.created_at | formatDate }}
              </div>
            </div>
          </b-col>

          <div class="col-md-12 mt-2">
            <div class="blue-jumbotron pt-2 pb-2">
              <h6 class="ml-2">{{ $t("associated_files") }}</h6>

              <!-- Display existing files -->
              <div
                  v-if="item.associate_files && item.associate_files.length > 0"
                  :key="index"
                  class="mt-1 row col-md-12 align-items-center"
                  v-for="(file, index) in item.associate_files"
              >
                <h5 class="mr-2">
                  <b-link>
                    <feather-icon
                        @click="readPdf(file)"
                        class="pointer web"
                        icon="BookOpenIcon"
                        size="22"
                    />
                  </b-link>
                  <b-link @click="readPdf(file)">
                    <feather-icon
                        class="pointer mobile"
                        icon="BookOpenIcon"
                        size="22"
                    />
                    {{ returnTitle(file) }}
                  </b-link>
                </h5>
                <div class="ml-xl-10">
                  {{ file.created_at | formatDate }}
                </div>

                <!-- Delete icon - Client can only delete their own files -->
                <div class="ml-auto" v-if="![1, 6, 8, 9, 10, 11, 14, 15].includes(item.status) && canDeleteFile(file)">
                  <feather-icon
                      @click="confirmDeleteFile(file)"
                      class="pointer text-danger"
                      icon="Trash2Icon"
                      size="18"
                  />
                </div>
              </div>

              <!-- Upload section for client - MULTIPLE FILES -->
              <div class="mt-3" v-if="![1, 6, 8, 9, 10, 11, 14, 15].includes(item.status)">
                <b-row class="col-md-12">
                  <b-col
                      @click="triggerClientFileInput"
                      class="col-md-12 text-center pointer"
                  >
                    <feather-icon icon="UploadIcon" size="22"/>
                    {{ $t("upload_files") }}
                  </b-col>
                  <div style="display: none">
                    <b-form-file
                        @change="uploadClientFiles($event)"
                        class="mt-1 mb-2 col-md-3"
                        ref="clientFileInput"
                        v-model="clientAssociated"
                        multiple
                        accept=".pdf,.jpg,.jpeg,.png"
                    ></b-form-file>
                  </div>
                </b-row>

                <!-- Show selected files before upload -->
                <b-row class="col-md-12 mt-2" v-if="selectedFiles.length > 0">
                  <b-col class="col-md-12">
                    <h6>{{ $t("you_selected") }}:</h6>
                    <div
                        v-for="(file, index) in selectedFiles"
                        :key="index"
                        class="d-flex align-items-center justify-content-between mb-2 p-2 alert alert-secondary"
                        style="border-radius: 4px;"
                    >
                      <span>
                        <feather-icon icon="FileIcon" size="16" class="mr-1"/>
                        {{ file.name }} ({{ formatFileSize(file.size) }})
                      </span>
                      <feather-icon
                          @click="removeSelectedFile(index)"
                          class="pointer text-danger"
                          icon="XIcon"
                          size="18"
                      />
                    </div>
                    <div class="d-flex justify-content-end">
                      <b-button
                          variant="primary"
                          size="md"
                          @click="confirmUploadFiles"
                          class="mt-2"
                      >
                        <feather-icon icon="UploadIcon" size="16"/>
                        {{ $t("upload") }} ( {{ selectedFiles.length }} )
                      </b-button>
                      <b-button
                          variant="secondary"
                          size="md"
                          @click="clearSelectedFiles"
                          class="mt-2 ml-2"
                      >
                        {{ $t("cancel") }}
                      </b-button>
                    </div>
                  </b-col>
                </b-row>

                <!-- Upload progress -->
                <b-row class="col-md-12 mt-2" v-if="uploadProgress.show">
                  <b-col class="col-md-12">
                    <b-progress
                        :value="uploadProgress.current"
                        :max="uploadProgress.total"
                        show-progress
                        animated
                    ></b-progress>
                    <small class="text-muted">
                      {{ $t("uploading") }} {{ uploadProgress.current }} / {{ uploadProgress.total }}
                    </small>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
        </b-col>
      </div>
    </div>
    <b-modal scrollable size="md" style="margin-top: 20vh !important;" v-model="levelErrorModal">
      <template #modal-footer="{ }" class="p-0 m-0">
        <p class="d-none">-</p>
      </template>
      <div>
        <div class="col-12 text-center pb-0 mb-0">
          <feather-icon icon="InfoIcon" size="40" variant="danger"/>
        </div>
        <span class="d-flex p-1 pt-0 mt-0" v-if="levelErrorData">
          <span v-if="$store.state.app.language == 'en'">
            The total value of your active invoices awaiting debtor confirmation or already offered for sale on the
            marketplace or already
            sold but not yet finalised exceeds the permitted trading limit of <strong>{{
              levelErrorData.level_total |
                  formatAmount
            }}</strong>
            of your status <strong>{{ levelErrorData.company_level }}</strong>, in which you are currently still located.
            As soon as you have finally settled invoices with a total value of <strong>{{
              levelErrorData.level_total |
                  formatAmount
            }} </strong>
            via Aequitex, you will move up to level <strong>{{ levelErrorData.company_next_level }}</strong> and can
            <strong>{{ levelErrorData.next_level_total | formatAmount }}</strong>.
          </span>
          <span v-else-if="$store.state.app.language == 'de'">
            Der Gesamtwert Ihrer aktiven Rechnungen, die auf eine Schuldner-Bestätigung warten oder bereits auf dem
            Marktplatz zum
            Verkauf angeboten werden oder aber bereits verkauft, jedoch noch nicht final abgewickelt wurden, übersteigt
            das
            zulässigen Handelslimit von <strong>{{ levelErrorData.level_total | formatAmount }}</strong> Ihres Status
            <strong>{{ levelErrorData.company_level }}</strong>,
            in dem Sie sich aktuell noch befinden. Sobald Sie Rechnungen im Gesamtwert von
            <strong>{{ levelErrorData.level_total | formatAmount }}</strong>
            über Aequitex final abgewickelt haben, steigen Sie in level
            <strong>{{ levelErrorData.company_next_level }}</strong> und können
            <strong>{{ levelErrorData.next_level_total | formatAmount }}</strong>.
          </span>
        </span>
      </div>
    </b-modal>
    <InformativeModal
        v-if="item.is_reverse !==1"
        :debtorConnected="debtorConnected" :disableAccept="disableAccept"
        :informativeModal="informativeModal"
        :item="item" :myComp="myComp" :settingsInfo="settingsInfo" @cancel="cancel"
        @saveSelling="saveSelling">
    </InformativeModal>

    <AddNewCompnayModal :company="companyZefixData" :invoice="invoice" :showDialog="addNewComp"
                        @closeAddCompModal="closeAddCompModal" @showSettings="showSettings"></AddNewCompnayModal>

    <MainContactModal :company="companyZefixDataMainContact" :invoice="invoice" :showDialog="MainContact"
                      @closeMainContactModal="closeMainContactModal" @showSettings="showSettings"></MainContactModal>
    <ApproveModal :textContent="modalText" :title="modalTitle"/>
  </b-card>
</template>
<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import fileDownload from "js-file-download";
import AddNewCompnayModal from "../cookpit/AddNewCompanyModal.vue";
import MainContactModal from "./MainContactModal.vue";
import ApproveModal from "@/components/common/ApproveModal";
import InformativeModal from "@/components/common/InvoiceDetailsEmail.vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal";
import InvoiceStatus from "@/components/invoices/InvoiceStatus";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import i18n from "@/libs/i18n";
import {VueAutosuggest} from "vue-autosuggest";
import {CurrencyAmountFormat} from '@core/utils/CurrencyAmountFormat';
import SetAutoRemoveDaysModal from "@/components/common/SetAutoRemoveDaysModal.vue";
import CalculationsHelper from "@/helpers/calculationsHelper";
import InvoiceDocuments from "./InvoiceDocuments.vue";

export default {
  data() {
    return {
      CalculationsHelper,
      disabledDueDates: null,
      error: '',
      prefillData: {
        sign_first: null,
        sign_last: null,
        sign_address_street: null,
        sign_address_zip: null,
        sign_address_city: null,
        sign_address_country: null,
        sign_email: null,
        sign_mobile: null,
        sign_phone_code: null,
        company_name: null,
        company_address_street: null,
        company_address_city: null,
        company_address_zip: null,
        company_address_country: null,
        invoice_number: null,
        issue_date: null,
        debtor_company_name: null,
        debtor_company_address_street: null,
        debtor_company_address_city: null,
        debtor_company_address_zip: null,
        debtor_company_address_country: null,
        invoice_id: null,
        due_days: null,
        repayment_amount: null
      },
      sorry_invoice_not_found: false,
      acceptReverse: false,
      levelErrorModal: false,
      levelErrorData: null,
      skribbleError: null,
      disableAccept: false,
      disableSell: false,
      sellingInvoice: false,
      buttonLoad: false,
      silent_factoring_accepted: true,
      resLoader: false,
      disabledOffer: false,
      acceptRecourse: false,
      validSubmit: false,
      isValid: false,
      valid: false,
      canSell: false,
      canScore: false,
      updatedInvoice: {},
      filteredOptions: [],
      company: this.$store.state.app.company.value,
      settings: {
        recourse: "",
        none_recourse: "",
        flash_sale: "",
        open_factoring: "",
        silent_factoring: "",
      },
      agreeTerms: "",
      load: true,
      addNewComp: false,
      uploadFileModal: false,
      associated: null,
      disabledFields: false,
      silentFactoring: false,
      MainContact: false,
      companyZefixDataMainContact: null,
      uploadedInvoce: {
        file: null,
        id: "",
      },
      fileType: "",
      fileDesc: "",
      item: null,
      options: [
        {
          value: 0,
          name: i18n.t("Non-Recourse"),
          title: "non_recourse_tooltip_title",
        },
        {
          value: 1,
          name: i18n.t("Recourse"),
          title: "recourse_tooltip_title",
        },
        {
          value: 2,
          name: i18n.t("Reverse"),
          title: "reverse_tooltip_title",
        },
        {
          value: 3,
          name: i18n.t("invoice_info_risk_discount_default_percent_tooltip"),
          title: "invoice_info_risk_discount_default_percent_tooltip",
        },
        {
          value: 4,
          name: i18n.t("invoice_info_risk_discount_default_amount_tooltip"),
          title: "invoice_info_risk_discount_default_amount_tooltip",
        },
      ],
      acceptReverseError: false,
      companies: [],
      approveModalAction: null,
      modalText: "",
      modalTitle: "",
      auditTrial: false,
      formatAmount: "",
      type: "",
      base64: "",
      showPdfViwer: false,
      showHint: false,
      companyMessage: "",
      myComp: null,
      companyZefixData: null,
      index: "",
      hasOwnership: false,
      saveDebtor: "",
      informativeModal: false,
      settingsInfo: {},
      loader: false,
      debtorConnected: null,
      additional_docs: [],
      additionalDocsUploaded: false,
      annual_balance: null,
      annual_balanceUploaded: false,
      annual_balance_req_error: false,
      tax_settlement: null,
      tax_settlementUploaded: false,
      tax_settlement_req_error: false,
      errorDueDate: "",
      companyBankData: {},
      currencies: null,
      currency_name: 'CHF',
      currency_id: 1,
      currencyError: null,
      global_settings: {},
      receivable_invoices: [],
      receivableInvoicesUploaded: false,
      invoicePollingTimer: null,
      pdfUrl: null,
      isAllowedToAcknowledge: true,
      signingUrl: null,
      register_url: null,
      pollInterval: null,
      documentSigned: false,
      showPopup: false,
      form_type: null,
      clientAssociated: null,
      selectedFiles: [],
      uploadProgress: {
        show: false,
        current: 0,
        total: 0
      },
      filesNameSupporting: [],
      filesNameAnnualFinancialStatements: [],
      filesNameBankStatement: [],
      filesNameInterimFinancialStatements: [],
      filesNameMasterAgreement: [],
      filesNamePurchaseOrder: [],
      filesNameDeliveryConfirmation: [],
      filesNameStatementOfWork: [],
    };
  },
  components: {
    SetAutoRemoveDaysModal,
    InvoiceStatus,
    StatisticCardHorizontal,
    ValidationProvider,
    ValidationObserver,
    ApproveModal,
    VueAutosuggest,
    MainContactModal,
    AddNewCompnayModal,
    InformativeModal,
    InvoiceDocuments,
  },
  props: ["invoice"],
  methods: {
    validateDays() {
      const days = this.item.auto_remove_days;

      if (!Number.isInteger(days) || days < 1 || days > 999) {
        this.error = "set_invoice_auto_remove_days_error";
        return false;
      }

      this.error = "";
      return true;
    },

    updateAutoRemoveTime(value) {
      this.autoRemoveTimeValue = value
    },

    async collectPrefillData() {

      const user = await this.refreshUser();
      let company = user.company
      let debtor = this.item.debtor
      const scoring = this.item.scorings[0]

      let iban = await this.getIbanWithCurrency(this.item.currency_id);
      let repayment_amount = 0;

      if(scoring) {
        repayment_amount = scoring.amount * 1 + scoring.discount_from_amount * 1
      }

      const options = {day: '2-digit', month: 'short', year: 'numeric'};

      const issue_date = new Date(this.item.issue_date);
      const due_date = new Date(this.item.due_date);
      const formattedIssueDate = issue_date
          .toLocaleDateString('en-GB', options)
          .replace(/ /g, '-');

      const formattedDueDate = due_date
          .toLocaleDateString('en-GB', options)
          .replace(/ /g, '-');

      const invoice_type = this.item.is_reverse === 1 ? "reverse" : this.item.recourse === 1 ? "recourse" : "non-recourse";

      this.prefillData.sign_first = user.first_name ?? '';
      this.prefillData.sign_last = user.last_name ?? '';
      this.prefillData.sign_address_street = (user.address ?? '') + ' ' + (user.address_nr ?? '');;
      this.prefillData.sign_address_zip = user.zip ?? '';
      this.prefillData.sign_address_city = user.city ?? '';
      this.prefillData.sign_address_country = user.country ? user.country.name : '';
      this.prefillData.sign_email = user.email ?? '';
      this.prefillData.sign_email = user.email ?? '';
      this.prefillData.sign_mobile = user.phone || "",
      this.prefillData.sign_phone_code = user.iso_code ?? 'CH',
      this.prefillData.sign_email = user.email ?? '';
      this.prefillData.company_name = company.name ?? '';
      this.prefillData.company_address_street = (company.address ?? '') + ' ' + (company.address_nr ?? '');;
      this.prefillData.company_address_city = company.city;
      this.prefillData.company_address_zip = company.zip ?? '';
      this.prefillData.company_address_country = user.company_country ?? '';
      this.prefillData.invoice_number = this.item.invoice_number ?? '';
      this.prefillData.invoice_currency = this.item.currency ? this.item.currency.name : '';
      this.prefillData.invoice_amount = this.amountFormatCurrency(this.item.amount, this.item.currency.name, 'type');
      this.prefillData.issue_date = formattedIssueDate;
      this.prefillData.due_date = formattedDueDate;
      this.prefillData.debtor_company_name = debtor ? debtor.name : '';
      this.prefillData.debtor_company_address_street = (debtor ? debtor.address : '') + ' ' + (debtor ? debtor.address_nr : '');
      this.prefillData.debtor_company_address_city = debtor ? debtor.city : '';
      this.prefillData.debtor_company_address_zip = debtor ? debtor.zip : '';
      this.prefillData.debtor_company_address_country = debtor ? debtor.country.name : '';
      this.prefillData.invoice_id = this.item.id;
      this.prefillData.iban = iban ?? '';
      this.prefillData.due_days = this.item.due_days;
      this.prefillData.repayment_amount = repayment_amount;
      this.prefillData.language = this.$i18n.locale ?? 'de';
      this.prefillData.invoice_type = invoice_type;

      if (this.isAllowedToAcknowledge) {
        await this.generateDebtAcknowledgement(this.prefillData);
      }
    },

    async getIbanWithCurrency(currency_id) {
      try {
        const { data } = await this.$http.post(`/currency/get-iban-with-currency/${currency_id}`);
        if (data && data.value) {
          return data.value;
        }
      } catch (err) {
        console.error("Failed to get iban:", err);
        return null;
      }
    },

    async refreshUser() {
      try {
        let user = this.$store.state.auth.user;
        const { data } = await this.$http.post(`/getUserDataWithId/${user.id}`);

        if (data && data.value) {
          this.$store.commit("auth/setUser", data.value);
          return data.value;
        } else {
          console.warn("No user returned from backend");
          return user;
        }
      } catch (err) {
        console.error("Failed to refresh user:", err);
        return this.$store.state.auth.user;
      }
    },

    async generateDebtAcknowledgement(prefillData) {
      this.disableSell = true;
      this.checkSigningStatus(this.form_type)

      try {
        const res = await this.$http.post('/skribble/debt-acknowledgement/generate-pdf', prefillData);
        this.pdfUrl = res.data.value.pdf_url;
      } catch (err) {
        console.error(err);
      }
    },

    async openSigningUrl() {
      this.buttonLoad = true;
      this.skribbleError = null;

      try {
        const res = await this.$http.post('/skribble/debt-acknowledgement/send-for-signing', this.prefillData);
        this.signingUrl = res?.data?.value?.signing_url ?? null;

        if (this.signingUrl) {
          window.open(this.signingUrl, "_blank");
          this.pollInterval = setInterval(() => this.checkSigningStatus(this.form_type), 10000);
        } else {
          this.skribbleError = "Internal server error";
        }
      } catch (err) {
        this.skribbleError = err.response?.data?.message || "Internal server error";
      } finally {
        this.buttonLoad = false;
      }
    },

    handlePopupConfirm() {
      this.showPopup = false;
      this.openSigningUrl();
    },

    handleButtonClick() {
      if (localStorage.getItem("hideSkribblePopup") === "true") {
        this.openSigningUrl();
      } else {
        this.showPopup = true;
      }
    },

    checkSigningStatus(form_type) {
      this.$http.post(`/skribble/check-status/${this.$store.state.auth.user.id}/${form_type}`, { invoice_id : this.item.id }).then((res) => {
        if (res.data?.value === 'SIGNED') {
          clearInterval(this.pollInterval)
          this.pollInterval = null
          this.documentSigned = true
          this.disableSell = false;
        }
      }).catch(err => {
        console.error('Error checking signing status', err)
      });
    },

    amountFormat(amount, currency) {
      return CurrencyAmountFormat(amount, currency)
    },

    amountFormatCurrency(amount, currency, type) {
      return CurrencyAmountFormat(amount, currency, type)
    },

    async getGlobalSetting() {
      await this.$http.post("/global_settings").then((res) => {
        if (res) {
          if (res.data.value) {
            this.global_settings = res.data.value;
          }
        }
      })
    },

    getCurrencies() {
      this.$http.post("/currency").then((response) => {
        if (response.data.status == 200) {
          this.currencies = response.data.value;
        }
      });
    },

    changeCurrency(id, name) {

      if (id) {
        this.currency_id = id;
      }

      if (name) {
        this.currency_name = name;
      }

    },

    openLink() {
      window.open("https://support-aequitex.zohobookings.eu/#/KMU", "_blank");
    },

    getTooltip(option) {
      return option && option.tooltip ? option.tooltip : "";
    },
    returnTitle(item) {
      if (item.file_name) {
        return item.file_name;
      }

      return this.$t(item.title);
    },
    acceptReverseChange(val) {
      if (val) {
        this.acceptReverseError = false;
      }
    },
    async saveSelling() {
      this.disableAccept = true;
      try {
        const params = {};
        if (this.item.recourse == 2) {
          params.company_bank_data = JSON.stringify(this.companyBankData);
        }

        const res = await this.$http.post(
            `/invoice/accept/${this.$route.params.id}`,
            params
        );

        if (res) {
          this.disableAccept = false;
          this.disableSell = false;
          if (res.data.status == 200) {
            this.showSuccessMessage(i18n.t("success"));
            this.getInvoice();
            this.informativeModal = false;
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          } else if (res.data.status == 500) {
            this.levelErrorModal = true;
            this.levelErrorData = res.data.value;
          } else {
            this.$swal({
              position: "center",
              icon: "error",
              showCancelButton: true,
              title: this.$t(res.data.message),
              showConfirmButton: true,
              customClass: {
                confirmButton: "btn btn-primary",
              },
              buttonsStyling: false,
            });
          }
          this.informativeModal = false;
        }
      } catch (error) {
        console.log("error", error);
        this.disableAccept = false;
        this.disableSell = false;
      }
    },
    cancel() {
      this.informativeModal = false;
    },
    sellInvoice2() {
      this.disableSell = true;
      this.sellingInvoice = true;

      if (this.item.status == 0) {
        this.editInvoice(true);
      }
      if (this.item.recourse == 1 || this.item.is_reverse == 1) {
        this.saveSelling();
      } else {
        this.informativeModal = true;
        this.disableSell = false;
        this.sellingInvoice = false;
      }
    },
    sellInvoice() {
      this.$http
          .post(`invoice/readyForSale`, {id: this.$route.params.id})
          .catch((error) => {
            console.log("error", error);
          })
          .then((res) => {
            if (res) {
              if (res.data.status == 200) {
                this.showSuccessMessage(
                    i18n.t("invoice_is_on_marketplace"),
                    "sold"
                );
              } else if (res.data.status == 404 || res.data.status == 500) {
                this.$swal({
                  position: "center",
                  icon: "error",
                  showCancelButton: true,
                  title: this.$t(res.data.message),
                  showConfirmButton: true,
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                  buttonsStyling: false,
                });
              }
            }
          });
    },
    scoreInvoice() {
      this.updatedInvoice = this.item;
      let data = {
        invoice_id: this.$route.params.id,
        // debtor_point: this.updatedInvoice.issuer_id,
        // seller_point: this.updatedInvoice.issue_date,
        due_date: this.updatedInvoice.due_date,
        terms: this.updatedInvoice.terms,
        amount: this.updatedInvoice.amount,
      };
      this.$refs.formValidate.validate().then((success) => {
        if (success) {
          this.$http
              .post(`invoice/scoring`, data)
              .catch((error) => {
                console.log("error", error);
              })
              .then((res) => {
                if (res) {
                  if (res.data.status == 200) {
                    this.showSuccessMessage(
                        i18n.t("invoice_scored_successfully")
                    );
                    this.getInvoice();
                    this.canSell = true;
                  } else if (res.data.status == 500) {
                    this.$swal({
                      position: "center",
                      icon: "error",
                      title: this.$t("debtor_not_trustable"),
                      showConfirmButton: false,
                      timer: 1500,
                      customClass: {
                        confirmButton: "btn btn-primary",
                      },
                      buttonsStyling: false,
                    });
                  }
                }
              });
        } else {
          this.notValid = false;
        }
      });
    },
    closeAddCompModal(data) {
      this.saveDebtor = data ? data[0].id : "";
      this.$bvModal.hide("AddCompany");
    },
    closeMainContactModal(data) {
      this.saveDebtor = data ? data[0].company_id : "";
      this.$bvModal.hide("MainContact");
    },
    showSettings() {
      this.addNewComp = false;
      this.openModal = false;
    },
    getStatistics() {
      this.$http
          .post(`/company/show/${this.$store.state.auth.user.company_id}`)
          .then((res) => {
            if (res) {
              this.myComp = res.data.value;
              this.$store.state.auth.user.company.level = res.data.value.level;
            }
          });
    },
    getSetings() {
      this.$http.post(`/settings/getMarket`).then((res) => {
        if (res) {
          this.settingsInfo = res.data.value;
        }
      });
    },
    async onSelected(val, item, index) {
      this.loader = true;
      item.company_name = val.item;
      await this.getCompanyDataFromZefix(item, index);
    },
    async getCompanyDataFromZefix(item, index) {
      if (typeof this.companies[item.company_name] != "undefined") {
        try {
          const res = await this.$http.post("/get-company-data-from-zefix", {
            search: this.companies[item.company_name],
          });

          if (res) {
            item.company_uid = res.data.value.uid;
            let data = {
              search: item.company_uid,
              invoice_id: item.id,
            };

            this.addNewComp = false;
            this.MainContact = false;

            const resInvoice = await this.$http.post(
                "/invoice/getCompany",
                data
            );

            if (resInvoice) {
              this.loader = false;
              if (
                  resInvoice.data.value &&
                  resInvoice.data.value.from == "Database"
              ) {
                this.saveDebtor = resInvoice.data.value.company.id;
                item.company_name = resInvoice.data.value.company.name;
              } else if (
                  resInvoice.data.value &&
                  resInvoice.data.value.from == "ContactPerson"
              ) {
                this.showMainContactModal(
                    item,
                    index,
                    resInvoice.data.value.company
                );
              } else {
                this.showModal(item, index, resInvoice.data.value.company);
              }
            }
          }
        } catch (error) {
          if (error.response && error.response.status === 0) {
            this.$swal({
              position: "center",
              icon: "error",
              title: 'Failed to load data due to CORS issue. Click again to retry.',
              showConfirmButton: true,
              showCancelButton: true,
              customClass: {
                confirmButton: "btn btn-primary",
              },
              buttonsStyling: false,
            });
          }
          console.error("Error:", error);
        }
      }
    },
    showMainContactModal(item, index, company) {
      this.addNewComp = false;
      this.MainContact = true;
      this.companyZefixDataMainContact = company;
      this.invoice = item;
      this.selectedIndex = index;
      this.$bvModal.show("MainContact");
    },
    showModal(item, index, company) {
      this.addNewComp = true;
      this.MainContact = false;
      this.companyZefixData = company;
      this.invoice = item;
      this.selectedIndex = index;
      this.$bvModal.show("AddCompany");
    },
    async searchForCompaniesName(item) {
      clearTimeout(this.timeout);
      clearTimeout(this.timeout);
      this.companyMessage = "";
      const self = this;
      this.timeout = setTimeout(async function () {
        if (item.company_name.length > 2) {
          self.showHint = true;
          self.companies = [];
          self.filteredOptions = [];

          try {
            const res = await self.$http.post(
                "/get-companies-name-from-zefix",
                {
                  search: item.company_name,
                }
            );

            let obj = res.data.value;
            let myArray = [];

            for (var prop in obj) {
              if (obj[prop] != self.myComp.uid) {
                myArray.push(prop);
              }
            }

            self.successMessage = false;
            self.showHint = false;
            self.filteredOptions.push({
              data: myArray,
            });
            self.companies = res.data.value;

            if (res.data.value.length < 1) {
              self.companyMessage = true;
            }
          } catch (error) {
            console.error("Error:", error);
            if (error.response && error.response.status === 0) {
              this.$swal({
                position: "center",
                icon: "error",
                title: 'Failed to load data due to CORS issue. Click again to retry.',
                showConfirmButton: true,
                showCancelButton: true,
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                buttonsStyling: false,
              });
            }
          }
        } else {
          self.companies = [];
          self.showHint = false;
          self.filteredOptions = [];
        }
      }, 1000);
    },
    declineForceUpdate() {
      this.$http
          .post(`/invoice/forceUpdate/${this.item.id}/decline`)
          .then((res) => {
            if (res.data.status == 200) {
              this.item = res.data.value;
            }
          });
    },
    acceptForceUpdate() {
      this.$http
          .post(`/invoice/forceUpdate/${this.item.id}/accept`)
          .then((res) => {
            if (res) {
              if (res.data.status == 200) {
                this.item = res.data.value;
              }
            }
          });
    },
    readPdf(item) {
      this.$store.commit("app/ON_SIDEBAR_CLICK", false);
      this.$http
          .post("/invoice/admin/associate/read/" + item.id, {
            responseType: "json",
          })
          .then((response) => {
            this.type = "";
            this.base64 = "";
            this.base64 = response.data.value.b64;
            this.type = response.data.value.ext;
            this.$store.commit("app/SET_FILE_TYPE", this.type);
            this.$store.commit("app/SET_FILE_BASE64", this.base64);
            window.open("/read-files", "_blank");
          })
          .catch((error) => {
            this.isLoading = false;
          });
    },
    readInvoice(item) {
      this.$http
          .post("/invoice/download/" + item.id, {}, {responseType: "blob"})
          .then((response) => {
            fileDownload(response.data, item.title);
          })
          .catch((error) => {
          });
    },
    parsedAmount(val) {
      setTimeout(() => {
        if (val) {
          this.formatAmount = Number(this.item.amount)
              .toFixed(2)
              .replace(/\d(?=(\d{3})+\.)/g, "$&'");
          document.getElementById("amount-input").value = this.formatAmount;
        }
      }, 1000);
    },
    validateUploadedFile(type) {
      return this[`${type}Uploaded`] || this.item.user_uploaded_analysis[type].name;
    },

    canDeleteFile(file) {
      // Client can only delete files they uploaded
      return file.user_id === this.currentUserId;
    },

    triggerClientFileInput() {
      this.$refs.clientFileInput.$el.querySelector('input').click();
    },

    uploadClientFiles(event) {
      const files = Array.from(event.target.files);

      if (files.length === 0) return;

      this.selectedFiles = [...this.selectedFiles, ...files];

      this.clientAssociated = null;
    },

    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
    },

    removeSelectedFile(index) {
      this.selectedFiles.splice(index, 1);
    },

    clearSelectedFiles() {
      this.selectedFiles = [];
      this.clientAssociated = null;
    },

    confirmUploadFiles() {
      if (this.selectedFiles.length === 0) return;

      this.$bvModal.msgBoxConfirm(
          this.$t('confirm_upload_files', { count: this.selectedFiles.length }),
          {
            title: this.$t('confirm_upload'),
            size: 'md',
            buttonSize: 'md',
            okVariant: 'primary',
            okTitle: this.$t('upload'),
            cancelTitle: this.$t('cancel'),
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
          }
      ).then(value => {
        if (value) {
          this.processFileUploads();
        }
      })
      .catch(err => {
        console.error('Error showing confirmation:', err);
      });
    },

    async processFileUploads() {
      this.uploadProgress.show = true;
      this.uploadProgress.current = 0;
      this.uploadProgress.total = this.selectedFiles.length;

      const uploadPromises = [];
      const errors = [];

      for (let i = 0; i < this.selectedFiles.length; i++) {
        const file = this.selectedFiles[i];

        try {
          await this.uploadSingleFile(file);
          this.uploadProgress.current++;
        } catch (error) {
          console.error(`Error uploading ${file.name}:`, error);
          errors.push(file.name);
        }
      }

      this.uploadProgress.show = false;

      if (errors.length !== 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('some_files_failed', { files: errors.join(', ') }),
            icon: "ErrorIcon",
            variant: "danger",
          },
        });
      } else {
        window.location.reload();
      }

      this.clearSelectedFiles();
    },

    async uploadSingleFile(file) {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('invoice_id', this.item.id);

      const response = await this.$http.post('/invoice/associate/upload', formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Upload failed');
      }

      return response.data;
    },

    confirmDeleteFile(file) {
      this.$bvModal.msgBoxConfirm(
          this.$t('are_you_sure_you_want_to_delete_this_file', {
            filename: this.returnTitle(file)
          }),
          {
            title: this.$t('delete_the_document'),
            size: 'md',
            buttonSize: 'md',
            okVariant: 'danger',
            okTitle: this.$t('delete'),
            cancelTitle: this.$t('cancel'),
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
          }
      ).then(value => {
        if (value) {
          this.deleteClientFile(file);
        }
      })
      .catch(err => {
        console.error('Error showing confirmation:', err);
      });
    },

    async deleteClientFile(file) {
      try {
        const response = await this.$http.post(`/invoice/associate/delete/${file.id}`);

        if (response) {
          window.location.reload();
        }
      } catch (error) {
        console.error('Error deleting file:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('error_deleting_file') || 'Failed to delete file',
            icon: "ErrorIcon",
            variant: "danger",
          },
        });
      }
    },

    changeInvoiceFact(value) {

      if (this.item.recourse == 1) {

        if (!this.annual_balance) {
          this.annual_balance_req_error = true
        }

        if (!this.tax_settlement) {
          this.tax_settlement_req_error = true
        }

        if (this.annual_balance_req_error && this.tax_settlement_req_error) {
          return "";
        }
      }

      this.acceptRecourse = value == true ? true : false;
      let data = {
        data: value ? 1 : 0,
      };
      let type = value == true ? "recourse" : "non-recourse";
      this.$http
          .post(`/invoice/change/${type}/${this.$route.params.id}`, data)
          .then((res) => {
            if (res) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: i18n.t("success"),
                  icon: "SuccessIcon",
                  variant: "success",
                },
              });
            }
          });
    },

    requestProofOfOwnershipPage() {
      this.$router.push(
          "/invoice/" +
          this.$route.params.id +
          "/request/" +
          this.item.invoice_number
      );
    },
    calculateDueDays() {
      if (this.item.due_date) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const dueDate = new Date(this.item.due_date);
        dueDate.setHours(0, 0, 0, 0);
        const differenceInTime = dueDate.getTime() - today.getTime();
        const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));
        this.item.due_days_calculated = differenceInDays >= 0 ? differenceInDays : 0;
      } else {
        this.item.due_days_calculated = null;
      }
    },

    changeTerms(item) {
      if (this.item.issue_date && this.item.due_date) {
        let compareDate = "";
        const startDate = new Date(this.item.issue_date);
        const endDate = new Date(this.item.due_date);
        const differenceInTime = endDate.getTime() - startDate.getTime();
        const differenceInDays = differenceInTime / (1000 * 3600 * 24);
        this.item.terms = Math.abs(Math.round(differenceInDays));
      } else if (item.issue_date && !item.due_date) {
        const startDate = new Date(item.issue_date);
        this.disabledDueDates = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + 1)
      }

      this.calculateDueDays();
    },
    changeDueDate(item) {
      this.errorDueDate = "";
      if (Number(item.terms) > 120) {
        this.errorDueDate = this.$t("max_allowed_days_is_120");
        return;
      }
      let newDate = new Date();
      if (this.item.issue_date && this.item.terms) {
        let term = Number(this.item.terms);
        let parsed = new Date(this.item.issue_date);
        newDate.setDate(parsed.getDate() + term);
        this.item.due_date = newDate.toISOString().split("T")[0];
      }
    },
    async getOffer() {
      this.resLoader = true;
      this.disabledOffer = true;
      await this.$nextTick();
      this.editInvoice();
    },
    async editInvoice(isFromSell = false) {
      if (!this.item) {
        return;
      }
      this.updatedInvoice = this.item;
      let data = new FormData();
      data.append(
          "debtor_id",
          this.saveDebtor ? this.saveDebtor : this.updatedInvoice.company.id
      );
      data.append("issue_date", this.updatedInvoice.issue_date);
      data.append("due_date", this.updatedInvoice.due_date);
      data.append("terms", this.updatedInvoice.terms);
      data.append("amount", this.updatedInvoice.amount);
      data.append("invoice_number", this.updatedInvoice.invoice_number);
      data.append("status", this.updatedInvoice.status);
      data.append("recourse", this.updatedInvoice.recourse);
      data.append(
        "accept_recourse",
        this.updatedInvoice.accept_recourse ? 1 : 0
      );
      data.append("is_reverse", this.acceptReverse);

      if (this.additional_docs && this.additional_docs.length > 0) {
        this.additional_docs.forEach((file, fileIndex) => {
          data.append(`additional_docs[${fileIndex}]`, file);
        });
      }

      if (this.updatedInvoice.recourse == 1 && !this.updatedInvoice.accept_recourse) {
        this.$refs.formValidate.validate();
        this.resLoader = false;
        this.disabledOffer = false;
        return "";
      }

      if (
        this.updatedInvoice.recourse == 1 &&
        (!this.validateUploadedFile("annual_balance") ||
          !this.validateUploadedFile("tax_settlement"))
      ) {
        this.$refs.formValidate.validate();
        this.resLoader = false;
        this.disabledOffer = false;
        return "";
      }
      if (this.updatedInvoice.recourse == 1) {
        data.append("annual_balance", this.annual_balance);
        data.append("tax_settlement", this.tax_settlement);
      }
      if (this.errorDueDate.length > 1) {
        this.$refs.formValidate.validate();
        this.resLoader = false;
        this.disabledOffer = false;
        return "";
      }

      let showErrorModal = false;
      try {
        const success = await this.$refs.formValidate.validate();
        this.currencyError = '';
        if (!this.currency_id) {
          this.currencyError = 'The Currency 0 field is required';
          return;
        }

        data.append("currency_id", this.currency_id);


        if (success) {

          if (this.item.recourse == 2 && this.acceptReverse) {
            this.acceptReverseError = true;
            this.notValid = true;
            showErrorModal = true;
          } else {
            data.append('company_bank_data', JSON.stringify(this.companyBankData));
            this.disableSell = false;
            this.notValid = false;
            this.disabledOffer = false;
            let config = {headers: {"Content-Type": "multipart/form-data"}};
            const res = await this.$http.post(`/invoice/update/${this.$route.params.id}`, data, config);

            if (res.data.status != 200) {
              showErrorModal = true;
              await this.$swal({
                position: "center",
                icon: "error",
                title: this.$t(res.data.message),
                showConfirmButton: false,
                showCancelButton: true,
                cancelButtonText: "OK!",
                customClass: {
                  cancelButton: "btn btn-outline-secondary",
                },
                buttonsStyling: false,
                persistent: true,
                allowOutsideClick: false,
              });
              if (result.dismiss === "cancel") {
                // window.location.reload()
              }
            } else {
              this.item = res.data.value;
              this.getInvoice();
              if (!isFromSell) {
                this.showSuccessMessage(i18n.t("success"));
              }
              this.canScore = true;
            }
          }
        } else {
          this.notValid = false;
          showErrorModal = true;

        }
      } catch (error) {
        console.error("Error:", error);
        this.disableSell = false;
        // Handle error
      } finally {
        if (!showErrorModal) {
          this.getInvoice();
        }
        this.resLoader = false;
        this.disabledOffer = false;
        this.disableSell = false;
      }
    },
    getSettings() {
      this.$http.post(`/company/settings`).then((res) => {
        if (res) {
          this.settings = res.data.value;
        }
      });
    },
    getInvoice() {
      this.$http.get(`/invoice/check/${this.$route.params.id}`).then((res) => {
        this.isAllowedToAcknowledge = res.data.value.allowedToView;
      });
      this.$http.post(`/invoice/show/${this.$route.params.id}`).then((res) => {
        if (res.data.status === 404) {
          this.sorry_invoice_not_found = true;
          return;
        }

        if (res) {
          this.item = res.data.value;
          this.item.amount = Number(this.item.amount).toFixed(2);

          this.changeTerms(this.item);

          if ((this.item.recourse != 0 || this.item.is_reverse != 0) && (this.item.status == 5 || this.item.status == 6) && this.item.offer_confirmed == 1) {
            this.collectPrefillData();
          }
          this.changeCurrency(this.item.currency_id, this.item.currency.name)

          let associate_files = res.data.value.associate_files;
          associate_files.forEach((element) => {
            if (element.title === "receivable_invoices") {
              this.receivableInvoicesUploaded = true;
            }
          });

          if (res.data) {
            this.item.recourse = res.data.value.recourse;
            let is_reverse = res.data.value.is_reverse == 1;
            if (is_reverse) {
              this.item.recourse = 2;
            }
            this.acceptRecourse = res.data.value.accept_recourse == 1 || res.data.value.is_reverse == 1  ? true : false;
          }
          if (
              res.data.value.associate_files &&
              res.data.value.associate_files.length > 0
          ) {
            this.annual_balanceUploaded = true;
            this.tax_settlementUploaded = true;
            this.additionalDocsUploaded = true;
          }
          if (
              res.data.value &&
              res.data.value.debtor &&
              res.data.value.debtor.main_contacts_debtor.length > 0
          ) {
            res.data.value.debtor.main_contacts_debtor.forEach((el) => {
              if (el.seller_id == this.item.company_id) {
                this.debtorConnected = el;
              }
            });
          }
          this.item.debtor = res.data.value.debtor
              ? res.data.value.debtor
              : {name: ""};
          if (!res.data.value.issuer_id) {
            this.canScore = false;
          } else {
            this.canScore = true;
          }
          this.updatedInvoice = res.data.value;
          this.item.silent = this.item.silent ? true : false;
          this.item.flash_sale = this.item.flash_sale ? true : false;
          if (this.item) {
            if (this.item.associate_files.length > 0) {
              const hasProofType = this.item.associate_files.some(
                  (item) =>
                      item.hasOwnProperty("type") &&
                      item.type === "Proof Of Ownership"
              );
              if (hasProofType) {
                this.hasOwnership = true;
              } else {
                this.hasOwnership = false;
              }
            }

            if (this.item.flash_sale == 0) {
              this.flashSale = false;
            } else {
              this.flashSale = true;
            }
            if (this.item.silent == 0) {
              this.silentFactoring = 0;
            } else {
              this.silentFactoring = 1;
            }

            if (this.item.amount == 0.0) {
              this.item.amount = null;
              this.parsedAmount(this.item.amount);
            }

            this.load = false;
            this.getCompanies();
            if (this.item.flash_sale == 0) {
            } else {
              this.flashSale = true;
            }
          }
        }
      });
    },
    triggerFileInput() {
      this.$refs.fileInput1.$refs.input.click();
    },
    triggerFileInput2() {
      this.$refs.fileInput2.$refs.input.click();
    },
    triggerFileInput3() {
      this.$refs.fileInput3.$refs.input.click();
    },
    triggerFileInput4() {
      this.$refs.fileInput4.$refs.input.click();
    },
    triggerFileInput5() {
      this.$refs.fileInput5.$refs.input.click();
    },
    uploadRecourseFile(event, fileType, index) {
      const files = event.target.files;
      if (!files || !files.length) return;

      switch (fileType) {
        case 'receivable_invoices':
          this.filesNameSupporting = [];
          for (let i = 0; i < files.length; i++) {
            this.filesNameSupporting.push(files[i].name);
          }
          this.uploadFile(event, 'receivable_invoices');
          break;

        case 'annual_financial_statements':
          this.filesNameAnnualFinancialStatements = [];
          for (let i = 0; i < files.length; i++) {
            this.filesNameAnnualFinancialStatements.push(files[i].name);
          }
          this.uploadFile(event, 'annual_balance');
          break;

        case 'bank_statement':
          this.filesNameBankStatement = [];
          for (let i = 0; i < files.length; i++) {
            this.filesNameBankStatement.push(files[i].name);
          }
          this.uploadFile(event, 'tax_settlement');
          break;

        case 'interim_financial_statements':
          this.filesNameInterimFinancialStatements = [];
          for (let i = 0; i < files.length; i++) {
            this.filesNameInterimFinancialStatements.push(files[i].name);
          }
          this.uploadFile(event, 'additional_docs');
          break;

        case 'master_agreement':
          this.filesNameMasterAgreement = [];
          for (let i = 0; i < files.length; i++) {
            this.filesNameMasterAgreement.push(files[i].name);
          }
          this.uploadFile(event, 'additional_docs');
          break;

        case 'purchase_order':
          this.filesNamePurchaseOrder = [];
          for (let i = 0; i < files.length; i++) {
            this.filesNamePurchaseOrder.push(files[i].name);
          }
          this.uploadFile(event, 'additional_docs');
          break;

        case 'delivery_confirmation':
          this.filesNameDeliveryConfirmation = [];
          for (let i = 0; i < files.length; i++) {
            this.filesNameDeliveryConfirmation.push(files[i].name);
          }
          this.uploadFile(event, 'additional_docs');
          break;

        case 'statement_of_work':
          this.filesNameStatementOfWork = [];
          for (let i = 0; i < files.length; i++) {
            this.filesNameStatementOfWork.push(files[i].name);
          }
          this.uploadFile(event, 'additional_docs');
          break;

        default:
          this.uploadFile(event, 'additional_docs');
      }
    },
    triggerFileInputAFS(index) {
      const el = document.getElementById('fileInputAFS' + index);
      if (el) el.click();
    },
    triggerFileInputBS(index) {
      const el = document.getElementById('fileInputBS' + index);
      if (el) el.click();
    },
    triggerFileInputIFS(index) {
      const el = document.getElementById('fileInputIFS' + index);
      if (el) el.click();
    },
    triggerFileInputMA(index) {
      const el = document.getElementById('fileInputMA' + index);
      if (el) el.click();
    },
    triggerFileInputPO(index) {
      const el = document.getElementById('fileInputPO' + index);
      if (el) el.click();
    },
    triggerFileInputDC(index) {
      const el = document.getElementById('fileInputDC' + index);
      if (el) el.click();
    },
    triggerFileInputSOW(index) {
      const el = document.getElementById('fileInputSOW' + index);
      if (el) el.click();
    },
    storeData() {
      let formData = new FormData();
      let config = {headers: {"Content-Type": "multipart/form-data"}};
      formData.append("pdf", this.associatedEvent.target.files[0]);
      this.$http
          .post(`/invoice/associate/upload/${this.item.id}`, formData, config)
          .then((res) => {
            if (res) {
              let data = {
                description: this.fileDesc,
                proof_of_ownership: this.fileType,
              };
              this.$http
                  .post(`/invoice/storeData/${res.data.value.id}`, data)
                  .then((response) => {
                    if (response) {
                      this.uploadFileModal = false;
                      this.showSuccessMessage("File Upload Successfully");
                      this.associated = null;
                      this.fileType = "";
                      this.fileDesc = "";
                    }
                  });
            }
          });
    },
    uploadFile(event, file) {
      const files = event.target.files;

      if (file === 'additional_docs') {
        for (let i = 0; i < files.length; i++) {
          this.additional_docs.push(files[i]);
          this.additionalDocsUploaded = true;
        }
      }
      if (file === 'receivable_invoices') {
        for (let i = 0; i < files.length; i++) {
          this.receivable_invoices.push(files[i]);
          this.receivableInvoicesUploaded = true;
        }
      }
      if (file == "annual_balance") {
        this.annual_balance = files[0];
        this.annual_balanceUploaded = true;
      } else if (file == "tax_settlement") {
        this.tax_settlement = files[0];
        this.tax_settlementUploaded = true;
      }

      this.associatedEvent = event;
      this.uploadFileModal = true;

    },
    changeModalInfo(action, title, text) {
      this.approveModalAction = action;
      this.modalText = text;
      this.modalTitle = title;
    },
    callApproveModalAction() {
      if (this.approveModalAction == "archive") {
        this.changeStatus("archive");
      } else if (this.approveModalAction == "remove") {
        this.changeStatus("remove");
      } else if (this.approveModalAction == "approve") {
        this.changeStatus("approve");
      } else if (this.approveModalAction == "status") {
        this.changeStatus("status");
      }
    },
    showSuccessMessage(message, type) {
      let text = this.$t(message);
      this.$swal({
        position: "center",
        icon: "success",
        title: text,
        showConfirmButton: false,
        timer: 1500,
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
      this.load = false;
      if (type == "remove" || type == "sold" || type == "edited") {
        this.$router.replace("/invoices");
      }
    },
    downloadFile(item) {
      this.$http
          .post(
              "/invoice/admin/associate/download/" + item.id,
              {},
              {
                responseType: "blob",
              }
          )
          .then((response) => {
            let parsed = response.data.type.split("/");
            let str = "doc." + parsed[1];
            fileDownload(response.data, item.title);
          })
          .catch((error) => {
          });
    },
    changeStatus(type) {
      let status = 0;
      let message = "";
      let route = "";
      if (type == "status") {
        if (this.item.status == 1) {
          status = 0;
        } else {
          status = 1;
        }
        message = i18n.t("status_changed_successfully");
      }
      if (type == "archive") {
        status = 2;
        message = i18n.t("invoice_has_been_archived_successfully");
      }
      if (type == "remove") {
        status = 99;
        route = "remove";
        message = i18n.t("invoice_has_been_removed_successfully");
      }
      if (type == "approve") {
        status = 1;
        message = i18n.t("invoice_has_been_approved_for_sale");
      }
      // 0: inactive
      // 1: active ready for sale
      // 2: archive
      // 99: remove
      this.$http
          .post(`/invoice/changeStatus/${this.$route.params.id}`, {
            status: status,
          })
          .then((res) => {
            if (res) {
              this.showSuccessMessage(message, route);
            }
          });
    },
    removeInvoice() {
      this.$http
          .post(`/invoice/remove/${this.$route.params.id}`)
          .then((res) => {
            if (res) {
              this.showSuccessMessage(i18n.t("removed_successfully"));
            }
          });
    },
    getCompanies() {
      this.$http
          .post("/company/admin/list?")
          .then((response) => {
            if (response.data.status == 200) {
              this.addNewComp = false;
              this.companies = response.data.value.data;
              this.companies.forEach((el) => {
                if (el.id > el.id + 1) {
                  this.selected = el;
                }
                if (el.uid == this.myComp.uid) {
                  el.disabled = true;
                }
              });
            }
          })
          .catch((error) => {
          });
    },
    startInvoicePolling() {
      if (this.invoicePollingTimer) clearInterval(this.invoicePollingTimer);
      this.invoicePollingTimer = setInterval(() => {
        this.pollInvoiceStatus();
      }, 60000); // 1 minute
      this.pollInvoiceStatus();
    },

    pollInvoiceStatus() {
      this.$http
        .post(`/invoice/status/${this.$route.params.id}`)
        .then((res) => {
          if (res && res.data && res.data.value) {
            let invoice_status = res.data.value;
            if (invoice_status === 5) {
              this.stopInvoicePolling();
              this.getInvoice()
            }
          }
        });
    },

    stopInvoicePolling() {
      if (this.invoicePollingTimer) {
        clearInterval(this.invoicePollingTimer);
        this.invoicePollingTimer = null;
      }
    },
    canRepublish(invoice) {
      if (!invoice) return false;

      const { status, hide_from_market, enable_date, due_date } = invoice;

      if (status !== 15 || hide_from_market !== 1) return false;
      if (!enable_date || !due_date) return false;

      const toMidnight = (d) => {
        const date = new Date(d);
        date.setHours(0, 0, 0, 0);
        return date;
      };

      const published = toMidnight(enable_date);
      const due = toMidnight(due_date);
      const now = toMidnight(new Date());

      const totalDays = (due - published) / (1000 * 60 * 60 * 24);
      const remainingDays = (due - now) / (1000 * 60 * 60 * 24);

      if (remainingDays <= totalDays / 2) return false;

      return true;
    },

    rePublish() {
      if (!this.validateDays()) return;

      const payload = { auto_remove_days: this.item.auto_remove_days };

      this.$http.post(`/invoice/republish/${this.$route.params.id}`, payload).then((res) => {
        if (res?.data?.status === 200) {
          window.location.reload();
        }
      })
    },
    getFormType(invoice_id) {
      this.$http.post(`/skribble/get-form-type/${invoice_id}`).then((res) => {
        this.form_type = res.data?.value?.form_type ?? '';
      });
    }
  },
  created() {
    this.getInvoice();
    this.getSettings();
    this.getCompanies();
    this.getStatistics();
    this.getSetings();
    this.getGlobalSetting();
    this.getCurrencies();
    this.startInvoicePolling();
  },
  beforeDestroy() {
    this.stopInvoicePolling();
  },
  watch: {
    item: {
      immediate: false,
      deep: true,
      handler(newVal) {
        if (!newVal || !newVal.id || this.form_type) return;
        this.getFormType(newVal.id);
      }
    }
  },
  computed: {
    currentUserId() {
      return this.$store.state.auth?.user?.id;
    },
    disabledDates() {
      var date = new Date();
      var today = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      this.disabledDueDates = today
      return today;
    },
    canSellInvoice() {
      const { offer_confirmed, scorings, status } = this.item || {};
      const filled = this.allFieldsFilled;
      const isAllowed = this.isAllowedToAcknowledge;
      const isScoringsArray = Array.isArray(scorings);
      const hasScorings = scorings?.length > 0;
      const isStatusFive = status === 5;

      const result = Boolean(
          isAllowed &&
          offer_confirmed &&
          isScoringsArray &&
          hasScorings &&
          isStatusFive &&
          filled
      );

      return result;
    },
    allFieldsFilled() {
      const invoice = this.item || {};

      const result = Boolean(
          invoice.amount &&
          invoice.issue_date &&
          invoice.terms &&
          invoice.due_date &&
          invoice.invoice_number &&
          (
              (invoice.recourse === 1 && this.acceptRecourse) ||
              (invoice.recourse === 2) ||
              invoice.recourse === 0
          )
      );

      return result;
    },
  },
};
</script>
<style>
.red-jumbotron {
  background: rgb(246, 176, 176);
}

.blue-jumbotron {
  background: rgba(240, 249, 245, 1);
  cursor: default;
}

.green-jumbotron {
  background: rgb(216, 255, 192);
}

.pointer {
  cursor: pointer;
}

.text-decoration-underline {
  text-decoration: underline;
}

.tooltip-inner {
  max-width: 460px;
}
</style>
